import { Button } from "antd";
// import QuizIdInput from "./QuizIdInput";
import { PlusOutlined } from "@ant-design/icons";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";

const QuizFooterActions = () => {
  const {
    setIsCreateMode,
    setEditableQuiz,
    isQuizEditable,
    quizData,
    limit,
  }: any = useQuizContext();
  const { lecQuizLim } = limit || {};
  return (
    <div
      className="footer-class"
      style={{
        justifyContent: "flex-end",
      }}
    >
      {/* <QuizIdInput />

      <Button icon={<DownloadOutlined />}>Import Quiz</Button> */}

      {isQuizEditable && quizData?.length < lecQuizLim && (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setIsCreateMode(true);
            setEditableQuiz({});
          }}
        >
          Create
        </Button>
      )}
    </div>
  );
};

export default QuizFooterActions;
